import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DialogContainer = styled.div`
  background-color: white;
  border-radius: 4px;
  min-width: 500px;
  max-width: 600px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.375rem;
  gap: 0.5rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: 10px;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const PasswordWrapper = styled.div`
  margin-top: 0px;
  width: 100%;
  min-width: 0;
`;

export const PasswordLabel = styled.label`
  display: block;
  font-family: "Lato";
  font-size: 1rem;
  line-height: 1;
  font-weight: bold;
  color: ${(props) => (props.hasError ? "red" : "#15aee5")};
  margin-bottom: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PasswordInputContainer = styled.div`
  position: relative;
`;

export const PasswordInput = styled.input`
  width: 100%;
  padding: 7px 40px 7px 10px;
  font-family: "Lato";
  font-size: 1rem;
  border: 1px solid ${(props) => (props.hasError ? "#c00" : "#4caf50")};
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
  
  &:focus {
    border-color: ${(props) => (props.hasError ? "#c00" : "#15aee5")};
  }
  
  &::placeholder {
    color: #999;
  }
`;

export const PasswordError = styled.span`
  display: block;
  color: #c00;
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 0.25rem;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;

  &:hover {
    color: #333;
  }

  i {
    font-size: 1rem;
  }
`;
